module.exports = __webpack_public_path__ + "img/store.c87851b2.svg";